/* global axios */
import ApiClient from './ApiClient';

class ProductsAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }

  getProducts(params = {}) {
    return axios.get(`${this.url}`, { params });
  }

  getProduct(publicId) {
    return axios.get(`${this.url}/${publicId}`);
  }

  getCategories() {
    return axios.get(`${this.url}/categories`);
  }

  getCustomFields() {
    return axios.get(`${this.url}/custom_fields`);
  }

  getSpecificationPresets() {
    return axios.get(`${this.url}/custom_fields/presets`);
  }

  createProduct(product) {
    return axios.post(`${this.url}`, { product });
  }

  updateProduct(publicId, product) {
    return axios.patch(`${this.url}/${publicId}`, { product });
  }

  deleteProduct(publicId) {
    return axios.delete(`${this.url}/${publicId}`);
  }

  createCategory(category) {
    return axios.post(`${this.url}/categories`, { category });
  }

  createVariant(productPublicId, variant) {
    return axios.post(`${this.url}/${productPublicId}/variants`, { variant });
  }

  requestImageUpload(productPublicId, image, upload) {
    return axios.post(`${this.url}/${productPublicId}/images/upload_url`, {
      image,
      upload,
    });
  }

  deleteImage(productPublicId, imagePublicId) {
    return axios.delete(
      `${this.url}/${productPublicId}/images/${imagePublicId}`
    );
  }

  createCustomField(customField) {
    return axios.post(`${this.url}/custom_fields`, {
      custom_field: customField,
    });
  }

  applySpecificationPreset(presetKey) {
    return axios.post(`${this.url}/custom_fields/apply_preset`, {
      preset_key: presetKey,
    });
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(settings) {
    return axios.patch(`${this.url}/settings`, settings);
  }
}

export default new ProductsAPI();
